<div class="flex flex-col">
  <div class="flex justify-between items-center m-4 border-b border-customBlueHard">
    <p class="text-general-title color-blue">
      {{ this.data.titule }}
    </p>

    <button
      (click)="closeModal()"
      class="flex! justify-center! items-center!"
      color="primary"
      mat-icon-button
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (data.text) {
    <div
      class="p-3 flex flex-col overflow-auto box-scroll text-general text-var(--color-text-primary)"
    >
      {{ this.data.text }}
    </div>
  }

  <div class="px-4 mx-4">
    <app-input-general
      [formControlGeneral]="email"
      [label]="'Email'"
      [placeholder]="'Email'"
    ></app-input-general>
  </div>

  <div class="flex justify-center pt-2 pb-4 w-full">
    <button
      [disabled]="!email.valid"
      mat-button
      class="w-45 h-13! rounded-xl text-white! bg-(--comp-button-bg-primary)!"
      (click)="sentEmail()"
    >
      Enviar
    </button>
  </div>
</div>
